import { FC } from 'react';
import { AxiosError } from 'axios';

import powerOff from 'assets/images/power-off.svg';

import { BaseError } from './BaseError';

const errorLargeKey = 'error.general_error.large_text';

export interface GeneralErrorProps {
    error: AxiosError;
}

export const GeneralError: FC<GeneralErrorProps> = ({ error }) => (
    <BaseError
        iconUrl={powerOff}
        errorCode={error?.response?.status ?? 500}
        keyLarge={errorLargeKey}
        keySmall={error?.message}
    />
);
